import apiClient from './apiClient';

// ============================================================
// Types — matched to backend models/models.go (pwc5n4f1)
// ============================================================

/** One approved abnormal delivery order in the writeoff candidate grid */
export interface WriteoffCandidateItem {
  do_no: string;
  sc_no: string;
  do_date: string | null;
  customer_code: string;
  customer_name: string;
  dept_code: string;
  dept_name: string;
  currency: string;
  untaxed_amount: number;
  taxed_amount: number;
  tax_amount: number;
  abnormal_reason: string; // FC120_24
  approval_status: string; // FC120_80
}

export interface PendingResponse {
  items: WriteoffCandidateItem[];
  total: number;
}

export interface WriteoffResultItem {
  do_no: string;
  success: boolean;
  message: string;
  new_stat: string;
}

export interface WriteoffResponse {
  results: WriteoffResultItem[];
  success: number;
  failed: number;
  message: string;
}

export interface WriteoffFilter {
  doStart: string;
  doEnd: string;
}

// FC120 full detail (reuses backend pwc204f1/models.FC120 json tags)
export interface FC120Detail {
  fc120_01: string;
  fc120_10: string;
  fc120_11: string | null;
  fc120_12: string;
  fc120_13: number;
  fc120_14: string;
  fc120_16: number;
  fc120_17: string;
  fc120_18: string;
  fc120_19: number;
  fc120_20: number;
  fc120_201: number;
  fc120_24: string;
  fc120_27: number;
  fc120_80: string;
  details?: FC121Detail[];
}

export interface FC121Detail {
  fc121_01: string;
  fc121_02: number;
  fc121_11: string;
  fc121_12: string;
  fc121_13: string;
  fc121_15: number;
  fc121_16: number;
  fc121_17: string;
  fc121_18: number;
  fc121_19: number;
  fc121_20: number;
  fc121_21: number;
  fc121_22: string;
  batches?: FC122Batch[];
}

export interface FC122Batch {
  fc122_01: string;
  fc122_02: number;
  fc122_03: number;
  fc122_11: string;
  fc122_12: number;
}

// ============================================================
// API methods
// ============================================================

export const c5n4Api = {
  // GET /api/pwc5n4f1/candidates?doStart=&doEnd=
  async getCandidates(filter: WriteoffFilter): Promise<PendingResponse> {
    const res = await apiClient.get('/api/pwc5n4f1/candidates', {
      params: {
        doStart: filter.doStart,
        doEnd: filter.doEnd,
      },
    });
    return res.data;
  },

  // GET /api/pwc5n4f1/detail/:doNo
  async getDetail(doNo: string): Promise<FC120Detail> {
    const res = await apiClient.get(`/api/pwc5n4f1/detail/${doNo}`);
    return res.data;
  },

  // POST /api/pwc5n4f1/writeoff
  async writeoff(doNos: string[], comment?: string): Promise<WriteoffResponse> {
    const res = await apiClient.post('/api/pwc5n4f1/writeoff', {
      do_nos: doNos,
      confirmed: true,
      comment: comment || '',
    });
    return res.data;
  },
};
